export default __webpack_public_path__ + "static/media/phone-straight.142fea90.svg";